import ModalHeader from '@modules/common/components/Modal/ModalHeader';
import { SSOType } from '@modules/workspaceSettings/types';
import { ChangeEvent, useState } from 'react';
import { ConfigureOIDCSSOConfigModalContent } from './ConfigureOIDCSSOConfigModalContent';
import { ConfigureSAMLSSOConfigModalContent } from './ConfigureSAMLSSOConfigModalContent';
import { ConfigureSSOSelectionModalContent } from './ConfigureSSOSelectionModalContent';

export const ConfigureSSOModalContent = () => {
  const [selectedSSOConfig, setSelectedSSOConfig] = useState<SSOType>(
    SSOType.SAML,
  );
  const [activeStep, setActiveStep] = useState<'selection' | 'configuration'>(
    'selection',
  );

  const onChangeSSOConfig = (event: ChangeEvent<HTMLInputElement>) => {
    setSelectedSSOConfig(event.target.value as SSOType);
  };

  const renderDialogContent = () => {
    if (activeStep === 'selection') {
      return (
        <ConfigureSSOSelectionModalContent
          onNext={() => setActiveStep('configuration')}
          selectedSSOConfig={selectedSSOConfig}
          onChangeSSOConfig={onChangeSSOConfig}
        />
      );
    }

    if (activeStep === 'configuration') {
      if (selectedSSOConfig === SSOType.SAML) {
        return (
          <ConfigureSAMLSSOConfigModalContent
            onBack={() => setActiveStep('selection')}
          />
        );
      }

      if (selectedSSOConfig === SSOType.OIDC) {
        return (
          <ConfigureOIDCSSOConfigModalContent
            onBack={() => setActiveStep('selection')}
          />
        );
      }
    }

    return null;
  };

  return (
    <>
      <ModalHeader title="Configure SSO" />
      {renderDialogContent()}
    </>
  );
};
